// import ReactGA from 'react-ga';
import GA4 from "react-ga4";
import { SETTINGS } from '../settings';
import {BllinkLogger} from "../utils/bllink_loggers";
import * as Sentry from "@sentry/react";


// https://analytics.google.com/analytics/web/#/report-home/a47715142w248022712p230153098
// const trackingId3 = 'UA-47715142-2';
// ReactGA.initialize(trackingId3);
// https://analytics.google.com/analytics/web/#/a47715142w248022712p230153098/admin/property/create
// https://www.npmjs.com/package/react-ga4
const trackingId4 = 'G-LXY6FQ86ZV';
GA4.initialize(trackingId4, {
    // todo make these setup on localhost
    gaOptions: {
        debug_mode: SETTINGS.debug,
    },
    gtagOptions: {
        debug_mode: SETTINGS.debug,
    },
});
// ReactGA.set({
//     // any data that is relevant to the user session
//     // that you would like to track with google analytics
//     // todo add user id if relevant or guest id
//     // userID: 1
// })

/**
 * @param {string} categoryName
 * @param {string} eventName
 * @param {string} value
 * @param {string} labelName
 * */
async function GAEvent(categoryName, eventName, value, labelName){
    try {
        // since ga4, this doesn't have to be a number
        value = value ?? 1;
        labelName = labelName || 'noLabel';
        // changing to gtag to allow value object and not number
        GA4.gtag('event', categoryName, value);

        BllinkLogger.info(`sent event categoryName`, categoryName,  ' value', value);

        // adding here to also send to segment and in the future
        // we'll just send from segment to google analytics and remove sending from FE
        if (window.analytics) {
            await window.analytics.track(eventName, {
                category: categoryName,  // Required
                action: eventName,       // Required
                label: labelName,
                value: value,
            });
        }
    } catch (e) {
        Sentry.captureMessage('Unable track event, check payload', 'error');
    }
}


BllinkLogger.info(`initialized google analytics`);

export {
    GAEvent
}
